export const MANAGED_INTEGRATIONS_CATEGORIES = {
  accounting: {
    value: 'accounting',
    label: 'Accounting',
  },
  crm: {
    value: 'crm',
    label: 'CRMs',
  },
  erp: {
    value: 'erp',
    label: 'Enterprise Resource Planning (ERP)',
  },
  other: {
    value: 'other',
    label: 'Other',
  },
} as const;

export const DEFAULT_INTEGRATION_NAME = 'default';
